module.exports = __webpack_public_path__ + "static/media/ConnectView.b85813fe.png";